import React from "react";

import { Switch } from "~/components/switch";
import { useScope } from "~/tools/impulse";

import type { WidgetSparkline } from "./form-state";

export interface WidgetSparklineFieldProps {
	name: string;
	sparkline: WidgetSparkline;
}

export const WidgetSparklineField: React.FC<WidgetSparklineFieldProps> = ({ name, sparkline }) => {
	const scope = useScope();

	return (
		<Switch checked={sparkline.getInput(scope)} name={name} onCheckedChange={(show) => sparkline.setInput(show)} />
	);
};
